import React, { useState } from 'react';
import { MdAdd, MdClose } from 'react-icons/md'

const TagInput = ({ tags, setTags }) => {

    const [inputvalue, setinputvalue] = useState("")

    const handleInputChange = (e) => {
        setinputvalue(e.target.value)
    }

    const addNewTag = () => {
        if (inputvalue.trim() !== "") {
            setTags([...tags, inputvalue.trim()])
            setinputvalue("")
        }
        console.log(setTags)
        console.log(tags)
    }


    const HandleKeyDown = (e) => {
        if (e.key === "Enter") {
            addNewTag();
        }
    }

    const handleRemoveTag = (tagtoRemove) => {
        setTags(tags.filter((tag) => tag !== tagtoRemove))
    }
    return (
        <div>
            {tags?.length > 0 && (<div className='flex items-center gap-2 flex-wrap mt-2'>
                {tags.map((tag, index) => (
                    <span key={index} className='flex items-center gap-2 text-slate-900 bg-slate-100 px-3 py-1 rounded' >
                        #{tag}
                        <button onClick={() => handleRemoveTag(tag)} >
                            <MdClose />
                        </button>
                    </span>
                ))
                }
            </div>)}
            <div className="flex items-center gap-4 mt-3">
                <input placeholder='Add tags' type="text" className="text-sm bg-gray-100  px-3 py-2 rounded-lg "
                    value={inputvalue}
                    onChange={handleInputChange}
                    onKeyDown={HandleKeyDown}    
                />
                <button className="flex items-center justify-center h-8 w-8 border hover:bg-blue-500 border-blue-400"
                    onClick={() => addNewTag()}
                >
                    <MdAdd className="text-2xl text-blue-700                    
                    hover:text-white" />
                </button>
            </div>
        </div>
    )
}

export default TagInput
